import { GET_PARTNER_LINK, RECEIVE_PARTNERS_LINK } from './types';
import { take, put, call, all, select } from 'redux-saga/effects';
import { requestHandler } from '../../../../service/fetcher.saga';

function* preGetPartnerLink() {
	while (true) {
		const action = yield take(GET_PARTNER_LINK);

		const { service } = yield select();
		const children = service.user.children;
		const { result } = yield call(
			requestHandler,
			'partners',
			'POST',
			{
				prefix: action.prefix,
				children: children || [],
			},
			'links'
		);

		yield put({
			type: RECEIVE_PARTNERS_LINK,
			data: result,
			prefix: action.prefix,
		});
	}
}

export default function* indexSaga() {
	yield all([preGetPartnerLink()]);
}
